import React, { useContext, useEffect, useRef, useState } from 'react';
import { SafeAreaView, TouchableOpacity, StyleSheet, View } from 'react-native';
import { Picker } from '@react-native-picker/picker';
// should convert to use this one:
//import DropDownPicker from 'react-native-dropdown-picker';
import styled from 'styled-components/native';
import { DataContext } from 'opidcore';
import _ from 'lodash';

import { BasicText, BasicText as Text, Label, SmallLabel } from '../Styles';
import Util from './Util';

//const StyledPicker = styled(DropDownPicker)`
const StyledPicker = styled(Picker)`
    height: 40px;
    margin: 12px;
`;

const styles = StyleSheet.create({
    pickerStyle: {
        color: "rgb(77, 77, 79)",
        fontFamily: "Red Hat Display",
        fontSize: 12,
        fontWeight: 'normal',
        letterSpacing: 0.5,
        textAlign: "left",
        justifyContent: "flex-end",
        minWidth: 200
    }
});

const InputSelect = ({field, label = undefined, onChange = undefined, style = {}, readOnly = false, options = [] , showEmpty = false, enabled = true, itemStyle = {}, pickerStyle = {}, flexDirection = "row", LabelType = SmallLabel}) => {
    const boundMagic = useContext(DataContext);
    const [selectedValue, setSelectedValue] = useState("");
    const pickerRef = useRef({focus: undefined});

    useEffect(()=>{
        //initial setup for the boundMagic
        if(boundMagic != undefined){
            if(onChange != undefined){
                boundMagic.magicalState(field, (val)=>{
                    //if we have a custom change event it will be called here once boundMagic has a new value
                    onChange(boundMagic, field, val);
                });
            }

            setSelectedValue(boundMagic.magicalGet(field));
        }
    },[onChange, boundMagic]);

    useEffect(()=>{
        if(selectedValue != "" && selectedValue != boundMagic.magicalGet(field)){
            boundMagic.magicalSet(field, selectedValue);
        }
    }, [selectedValue]);

    if(readOnly == true){
        let displayValue = "";
        let index = _.indexOf(options, selectedValue);
        
        if(index == -1){
            index = _.findIndex(options, {value: selectedValue});
            if(index >= 0){
                displayValue = options[index].label;
            }
        } else {
            displayValue = options[index];
        }
        return <Text>{displayValue}</Text>;
    }

    const activatePicker = (a)=>{
        if(pickerRef.current != undefined && pickerRef.current.focus != undefined){
            pickerRef.current.focus();
        }
    }

    const defaultStyle = {
        flexDirection: flexDirection,
        margin: 0,
        justifyContent: "center",
        alignItems: "center",
        padding: 0,
        height: 50
    };
    
    return <View style={[defaultStyle, style]}>
        {label == undefined? null : <TouchableOpacity onPress={()=>activatePicker(pickerRef)}><LabelType>{label}</LabelType></TouchableOpacity>}
        <Text> </Text>
        <StyledPicker
            onValueChange={(itemValue, itemPosition)=>{
                setSelectedValue(itemValue);
            }}
            selectedValue={selectedValue}
            enabled={enabled}
            ref={pickerRef}
            style={[styles.pickerStyle, pickerStyle]}
            itemStyle={itemStyle}
            mode="dialog"
        >
            {showEmpty == true ? <Picker.Item key={"empty"} label={null} value={""} /> : null}
            {_.map(options, (o, i) => {
                return <Picker.Item key={o.value} label={o.label} value={o.value}/>;
            })}
        </StyledPicker>
    </View>;
}

export default InputSelect;